export const pricingConstants = {
  FETCH_PRICING_SUCCESS: 'FETCH_PRICING_SUCCESS',
  FETCH_PRICING_FAILURE: 'FETCH_PRICING_FAILURE',
  FETCH_PAYMENT_METHOD_SUCCESS: 'FETCH_PAYMENT_METHOD_SUCCESS',
  FETCH_PAYMENT_METHOD_FAILURE: 'FETCH_PAYMENT_METHOD_FAILURE'
};

export const termsConditionsConstants = {
  UPDATE_TERMS_CONDITIONS_SUCCESS: 'UPDATE_TERMS_CONDITIONS_SUCCESS',
  UPDATE_TERMS_CONDITIONS_FAILURE: 'UPDATE_TERMS_CONDITIONS_FAILURE'
};

// Monthly active learner pricing tiers. A site falls into exactly one tier and is
// billed that tier's flat monthly amount. Keep in sync with the Stripe Price tiers —
// Stripe is what actually bills, this table only drives the on-screen quote.
export const PRICING_TIERS = [
  { min: 1, max: 100, price: 315 },
  { min: 101, max: 250, price: 525 },
  { min: 251, max: 500, price: 788 },
  { min: 501, max: 1000, price: 1181 },
  { min: 1001, max: 2500, price: 1943 },
  { min: 2501, max: 5000, price: 2363 },
  { min: 5001, max: 10000, price: 3675 }
];

// Each tier owns its own fixed block of slider positions, so the first position in
// a block lands exactly on the tier's min and the last exactly on its max. That is
// what makes every tier boundary selectable; a single continuous scale across the
// whole range skips over most of them.
export const SLIDER_STEPS_PER_TIER = 10;

// One position past the last tier stands for "more than 10,000 learners", where we
// show a contact-sales message rather than a quote.
export const SLIDER_MAX_POSITION = PRICING_TIERS.length * SLIDER_STEPS_PER_TIER;

/**
 * Index into PRICING_TIERS for a slider position, or -1 past the top tier.
 */
export const tierIndexForPosition = (position) => {
  if (position >= SLIDER_MAX_POSITION) {
    return -1;
  }

  return Math.floor(position / SLIDER_STEPS_PER_TIER);
};

/**
 * Monthly active learners for a slider position, or null past the top tier.
 */
export const learnersForPosition = (position) => {
  const tierIndex = tierIndexForPosition(position);
  if (tierIndex < 0) {
    return null;
  }

  const tier = PRICING_TIERS[tierIndex];
  const offset = position - tierIndex * SLIDER_STEPS_PER_TIER;

  return Math.round(tier.min + ((tier.max - tier.min) * offset) / (SLIDER_STEPS_PER_TIER - 1));
};

/**
 * Monthly price for a slider position, or null past the top tier.
 */
export const priceForPosition = (position) => {
  const tierIndex = tierIndexForPosition(position);

  return tierIndex < 0 ? null : PRICING_TIERS[tierIndex].price;
};

export const dateFormat = 'MMMM DD, YYYY';
export const apiDateFormat = 'DD-MM-YYYY';
export const displayFormat = 'DD-MM-YYYY';
export const nanoSecondsToSecond = 1000;

export const userSliderConstants = {
  SET_COUNT: 'SET_COUNT'
};

const fetchPaymentMethodSuccess = (paymentMethod) => {
  return { type: pricingConstants.FETCH_PAYMENT_METHOD_SUCCESS, payload: paymentMethod };
};

const fetchPaymentMethodFailure = (error) => {
  return { type: pricingConstants.FETCH_PAYMENT_METHOD_FAILURE, payload: error };
};

const updateTermsConditionsSuccess = (response) => {
  return { type: termsConditionsConstants.UPDATE_TERMS_CONDITIONS_SUCCESS, payload: response };
};

const updateTermsConditionsFailure = (error) => {
  return { type: termsConditionsConstants.UPDATE_TERMS_CONDITIONS_FAILURE, payload: error };
};

export const termsConditionsDispatches = {
  updateTermsConditionsSuccess,
  updateTermsConditionsFailure
};

export const pricingDispatches = {
  fetchPaymentMethodSuccess,
  fetchPaymentMethodFailure
};
